<div class="centered">
    <img src="assets/images/loaderAnime.gif" alt="Loading" srcset="" />
</div>
@if (invalidToken) {
    <p>Invalid Token</p>
}
